<template>
    <div>
        <div id="fb-root"></div>
        <div class="fb-login-button" data-onlogin="onFacebookLogin();" data-size="medium" data-button-type="login_with" data-layout="default" data-auto-logout-link="false" data-use-continue-as="true" data-scope="read_insights,pages_show_list,ads_management,business_management,instagram_basic,instagram_manage_insights,instagram_content_publish,pages_read_engagement,pages_manage_posts,public_profile"></div>
    </div>
</template>
<script>

import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export default {
  name: 'facebookLogin',
  props: {
    onSuccess: {type: Function, required: true}
  },
  data () {
    return {
      // app dev : id: 709943733383587 - secret: a8883a3dc6d73294bcf16d6660b2eb53
      // app dev 2 : id: 811967143434375 - secret: 5bffb130720f35ecc6cbb31a053808f9
      // app prod : id: 1061578271001004 - secret: 87c15c9beeb6dedf76eed201669ab958
      facebookClientId: '811967143434375',
      facebookClientSecret: '5bffb130720f35ecc6cbb31a053808f9',
      facebookConnectUrl: 'https://connect.facebook.net/fr_FR/sdk.js',
      facebookTokenUrl: 'https://graph.facebook.com/v15.0/oauth/access_token?grant_type=fb_exchange_token&client_id=' + this.facebookClientId + '&client_secret=' + this.facebookClientSecret
    }
  },
  beforeMount () {
    this.loadFacebookSDK(document, 'script', 'facebook-jssdk')
    this.initFacebook()
    window.onSuccessFunction = this.onSuccess
  },
  methods: {
    async initFacebook () {
      const params = {
        appId: this.facebookClientId,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v15.0'
      }
      window.fbAsyncInit = function () { window.FB.init(params) }

      window.onFacebookLogin = res => {
        window.FB.getLoginStatus(function (response) {
          if (response.status === 'connected') {
            const accessToken = response.authResponse.accessToken
            const params = { access_token: accessToken }
            const facebookData = HTTP_HYPER_ESPACE_BACKEND.post('/facebook/connect', params).then(response => {
              this.onSuccessFunction()
              return response
            }).catch(error => {
              console.log(error)
            })
            return facebookData
          } else {
            console.log('getLoginStatus error')
          }
        })
      }
    },
    async loadFacebookSDK (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      const js = d.createElement(s)
      js.id = id
      js.src = this.facebookConnectUrl
      fjs.parentNode.insertBefore(js, fjs)
    }
  }
}

</script>
<style>
</style>
